module.exports = __webpack_public_path__ + "img/thumb-007-02.95a31929.png";